import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Othereditions from '../sec_pdp/_product-othereditions/component';
import AddToCartButton from '../ui_add-to-cart-button/component';
import PriceBlock from '../base_price-block/component';
import Typeset from '../base_typeset/component';
import Checkbox from '../ui_checkbox/component';
import { Product } from '@utils/product';
import { t } from '@utils/i18n';
import Text from '@components/ui_text/component';

import './styles/styles.scss';


/**
 * eBook Modal Notification
 *
 */
class EbookModalNotification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      buttonDisabled: true,
    };
  }

  get product() {
    const { product, store, sku } = this.props;
    if (!!product && (product instanceof Product)) {
      return product;
    }
    return new Product(store.getProduct(sku));
  }

  getPersons() {
    if (this.product.persons.length > 0) {
      return this.product.persons.map(person => person.name).join(', ');
    }
    return '';
  }

  getNotification = () => {
    return this.product.offered === 2 ? <Text>ebook.modal.notification.reservation</Text> : <Text>ebook.modal.notification</Text>;
  };

  get productOtherEditions() {
    return this.product.otherEditionsJson || {};
  }

  handleCheck = () => {
    this.setState(prevState => ({
      checked: !prevState.checked,
      buttonDisabled: !prevState.buttonDisabled,
    }));
  };

  render() {
    const { store } = this.props;
    const { checked } = this.state;
    return (
      <div className="ebook-modal-notification" data-test-id="modal-ebookNotification">
        <p>{t('ebook.modal.read-on-ereader') }</p>
        <div className="item-container">
          <div className="img-container">
            <img src={this.product.image} alt={this.product.name}/>
          </div>
          <div className="item">
            <p className="item-title">{this.product.name}</p>
            <p className="author">{this.getPersons()}</p>
            <PriceBlock product={this.product} store={store} />
          </div>

          {!!this.productOtherEditions.items && this.productOtherEditions.items.length > 1 && (
            <div className="alternatives">
              <p>{ t('ebook.modal.other-editions') }</p>
              <Othereditions data={this.productOtherEditions} store={store}/>
            </div>
          )}

        </div>
        <p className="download-notification">{this.getNotification()}</p>

        <div className="button-container modal-popup">
          <div className="checkbox">
            <label>
              <Checkbox checked={checked} onClick={this.handleCheck}/>
              <Typeset tight>{t('ebook.modal.checkbox-label') }</Typeset>
            </label>
          </div>
          <AddToCartButton
            product={this.product}
            store={store}
            inModal={true}
            disabled={this.state.buttonDisabled}
            showQuantity={true}
            showOrderlineReference={true}
          />
        </div>

      </div>
    );
  }
}

EbookModalNotification.propTypes = {
  /**
   * The title of the button. You see this when you hover over the button
   */
  name: PropTypes.string,
  /**
   * You can place extra attributes to this component. E.g. for google analytics
   * See the button explenation for extraAttributes.
   */
  sku: PropTypes.string,
  /**
   * The flag returned by product API
   * with the availability of a given product.
   */
  offered: PropTypes.number,
  /**
   * The product type of the product
   */
  productType: PropTypes.string,
  /**
   * the store
   */
  store: PropTypes.object,
  /**
   * the specific ebook
   */
  product: PropTypes.object,
};

export default EbookModalNotification;
